import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Spinner } from "reactstrap";
import Select from "react-select";
import { stylesSelect, DropdownIndicator, ClearIndicator } from "../../../Store/styled/select";
import { Formik, Form, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  getLedgerReportList,
  getTradeReport,
  setOpenModalTradeData,
  setOpenTradeData,
} from "../../../Store/Reducer/report.slice";
import DatePicker from "react-datepicker";
import {
  getAccountCommonList,
  setAccountOptionList,
  setAgentORSubBrokerList,
} from "../../../Store/Reducer/common.slice";
import moment from "moment";
import { formatUiDate, formatUiDateTime, UI_DATEPICKER_FORMAT } from "utils/dateFormats";
import { getSessionData } from "utils/common";
import { getAuthoritysList } from "../../../Store/Reducer/adminSlice/admin.slice";
import TradePopup from "./TradePopup.js";
import useMobileViewport from "hooks/useMobileViewport";
import MobileRecordCard from "components/mobile/MobileRecordCard";
import MobileRecordList from "components/mobile/MobileRecordList";

const optionsOfHead = [
  { value: 0, label: "All" },
  { value: 1, label: "Customer" },
  { value: 4, label: "Authority" },
  { value: 3, label: "Sub Broker" },
  { value: 2, label: "Other Account" },
];

const optionsOfFilter = [
  { value: 1,  label: "BILLING" },        { value: 2,  label: "BONUS IN" },
  { value: 3,  label: "BONUS OUT" },      { value: 4,  label: "BONUS ALL" },
  { value: 5,  label: "CASH IN" },        { value: 6,  label: "CASH OUT" },
  { value: 7,  label: "CASH ALL" },       { value: 8,  label: "CREDIT IN" },
  { value: 9,  label: "CREDIT OUT" },     { value: 10, label: "CREDIT ALL" },
  { value: 11, label: "POINT IN" },       { value: 12, label: "POINT OUT" },
  { value: 13, label: "POINT ALL" },      { value: 14, label: "SETTLE IN" },
  { value: 15, label: "SETTLE OUT" },     { value: 16, label: "SETTLE ALL" },
  { value: 17, label: "SHORT TRADE IN" }, { value: 18, label: "SHORT TRADE OUT" },
  { value: 19, label: "SHORT TRADE ALL"}, { value: 20, label: "OTHER" },
];

// ─── Table ───────────────────────────────────────────────────────────────────

function TableReportLedger({ ledgerReportList, ledgerReportLoading, headType, initialLeaderReport }) {
  const dispatch = useDispatch();
  const { userRole } = useSelector(({ auth }) => auth);
  const isMobileViewport = useMobileViewport();
  const [data, setData] = useState([]);
  const [sortKey, setSortKey]  = useState(null);
  const [sortAsc, setSortAsc]  = useState(true);

  useEffect(() => {
    setData(ledgerReportList?.length > 0 ? ledgerReportList : []);
  }, [ledgerReportList]);

  useEffect(() => { setData([]); }, [headType]);

  const handleSort = (key) => {
    if (sortKey === key) setSortAsc(p => !p);
    else { setSortKey(key); setSortAsc(true); }
  };

  const sortedData = React.useMemo(() => {
    if (!sortKey) return data;
    return [...data].sort((a, b) => {
      const av = a[sortKey] ?? "", bv = b[sortKey] ?? "";
      if (av < bv) return sortAsc ? -1 : 1;
      if (av > bv) return sortAsc ?  1 : -1;
      return 0;
    });
  }, [data, sortKey, sortAsc]);

  const openPdf = (row) => {
    dispatch(getLedgerReportList({
      ...initialLeaderReport,
      userId    : { value: row.userId, label: `${row.particulars} (${row.document})` },
      reportType: 2,
      single_user: true,
    }));
  };

  const SortArrow = ({ col }) => (
    <span style={{ marginLeft: 3, fontSize: 9, opacity: .7 }}>
      {sortKey === col ? (sortAsc ? "▲" : "▼") : "⇅"}
    </span>
  );

  const debitTotal  = data.reduce((s, r) => s + (r.debitAmount  || 0), 0);
  const creditTotal = data.reduce((s, r) => s + (r.creditAmount || 0), 0);

  if (isMobileViewport && headType?.value === 0 && userRole !== "User") {
    return (
      <div className="rpt-table-panel rpt-table-panel--mobile-cards fx-module--mobile-cards">
        <MobileRecordList
          loading={ledgerReportLoading && sortedData.length === 0}
          loadingText="Loading ..."
          empty={!ledgerReportLoading && sortedData.length === 0}
          emptyText="No data found"
        >
          {sortedData.map((row, idx) => (
            <MobileRecordCard
              key={idx}
              title={row.particulars}
              subtitle={row.document}
              fields={[
                { label: "Sr.No.", value: row.srNo },
                {
                  label: "Balance",
                  value: row.balance ? Math.round(row.balance) : 0,
                  tone: row.crDr === "Dr" ? "red" : "green",
                },
              ]}
            >
              <div style={{ marginTop: 8 }}>
                <a
                  href="#"
                  onClick={(e) => { e.preventDefault(); openPdf(row); }}
                  style={{ color: "var(--blue)", textDecoration: "none", fontSize: 12, fontWeight: 600 }}
                >
                  View account details
                </a>
              </div>
            </MobileRecordCard>
          ))}
        </MobileRecordList>
      </div>
    );
  }

  if (isMobileViewport) {
    return (
      <div className="rpt-table-panel rpt-table-panel--mobile-cards fx-module--mobile-cards">
        <MobileRecordList
          loading={ledgerReportLoading && sortedData.length === 0}
          loadingText="Loading ..."
          empty={!ledgerReportLoading && sortedData.length === 0}
          emptyText="No data found"
        >
          {sortedData.map((row, idx) => (
            <MobileRecordCard
              key={idx}
              title={row.particulars}
              subtitle={row.date ? formatUiDate(row.date, "-") : "-"}
              fields={[
                { label: "Sr.No.", value: row.srNo },
                { label: "Debit", value: row.debitAmount ? Math.round(row.debitAmount) : 0, tone: "red" },
                { label: "Credit", value: row.creditAmount ? Math.round(row.creditAmount) : 0, tone: "green" },
                {
                  label: "Balance",
                  value: row.balance ? Math.round(row.balance) : 0,
                  tone: row.crDr === "Dr" ? "red" : "green",
                },
                { label: "Dr/Cr", value: row.crDr, tone: row.crDr === "Dr" ? "red" : "green" },
                { label: "Description", value: row.document, fullWidth: true },
                { label: "Add Time", value: formatUiDateTime(row.addTime, "-"), fullWidth: true },
              ]}
            >
              <div style={{ display: "flex", gap: 12, marginTop: 8, fontSize: 12 }}>
                {row.particulars === "Trades" && (
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(setOpenTradeData(row));
                      dispatch(setOpenModalTradeData(true));
                    }}
                    style={{ color: "var(--blue)", textDecoration: "none" }}
                  >
                    View Trades
                  </a>
                )}
                {row.valanId > 0 && (
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(getTradeReport({ ...row, ledger: 1 }));
                    }}
                    style={{ color: "var(--text-muted)" }}
                  >
                    PDF
                  </a>
                )}
              </div>
            </MobileRecordCard>
          ))}
          {data.length > 0 && (
            <MobileRecordCard
              title="Totals"
              fields={[
                { label: "Debit", value: Math.round(debitTotal), tone: "red" },
                { label: "Credit", value: Math.round(creditTotal), tone: "green" },
              ]}
            />
          )}
        </MobileRecordList>
      </div>
    );
  }

  // "All" summary view
  if (headType?.value === 0 && userRole !== "User") {
    return (
      <div className="rpt-table-panel">
        <div className="rpt-table-scroll">
          <table className="rpt-table">
            <thead>
              <tr>
                <th className="sortable text-center" onClick={() => handleSort("srNo")}>
                  Sr.No. <SortArrow col="srNo" />
                </th>
                <th className="sortable" onClick={() => handleSort("document")}>
                  Account No <SortArrow col="document" />
                </th>
                <th className="sortable" onClick={() => handleSort("particulars")}>
                  Account Name <SortArrow col="particulars" />
                </th>
                <th className="text-right">Balance</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx}>
                  <td className="text-center col-muted">{row.srNo}</td>
                  <td>{row.document}</td>
                  <td>
                    <a href="#" onClick={(e) => { e.preventDefault(); openPdf(row); }}
                      style={{ color: "var(--blue)", textDecoration: "none" }}
                      onMouseEnter={e => e.target.style.textDecoration = "underline"}
                      onMouseLeave={e => e.target.style.textDecoration = "none"}
                    >
                      {row.particulars}
                    </a>
                  </td>
                  <td className={`text-right ${row.crDr === "Dr" ? "col-red" : "col-green"}`}>
                    {row.balance ? Math.round(row.balance) : 0}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {ledgerReportLoading && <div className="rpt-loading">Loading ...</div>}
          {!ledgerReportLoading && data.length === 0 && <div className="rpt-empty">No data found</div>}
        </div>
      </div>
    );
  }

  return (
    <div className="rpt-table-panel">
      <div className="rpt-table-scroll">
        <table className="rpt-table">
          <thead>
            <tr>
              <th className="text-center">Date</th>
              <th className="text-center">Sr.No.</th>
              <th className="text-center">Particulars</th>
              <th className="text-center" style={{ width: 40 }}>PDF</th>
              <th className="text-right">Debit</th>
              <th className="text-right">Credit</th>
              <th className="text-right">Balance</th>
              <th className="text-center">Dr/Cr</th>
              <th>Description</th>
              <th>Add Time</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((row, idx) => (
              <tr key={idx}>
                <td className="text-center col-muted">
                  {row.date ? formatUiDate(row.date, "-") : "-"}
                </td>
                <td className="text-center col-muted">{row.srNo}</td>
                <td className="text-center">
                  {row.particulars === "Trades" ? (
                    <a href="#" onClick={(e) => { e.preventDefault(); dispatch(setOpenTradeData(row)); dispatch(setOpenModalTradeData(true)); }}
                      style={{ color: "var(--blue)", textDecoration: "none" }}
                    >
                      Trades
                    </a>
                  ) : row.particulars}
                </td>
                <td className="text-center">
                  {row.valanId > 0 && (
                    <a href="#" onClick={(e) => { e.preventDefault(); dispatch(getTradeReport({ ...row, ledger: 1 })); }}
                      style={{ color: "var(--text-muted)" }}
                    >
                      <i className="material-icons-outlined" style={{ fontSize: 16 }}>description</i>
                    </a>
                  )}
                </td>
                <td className="text-right col-red">{row.debitAmount  ? Math.round(row.debitAmount)  : 0}</td>
                <td className="text-right col-green">{row.creditAmount ? Math.round(row.creditAmount) : 0}</td>
                <td className={`text-right ${row.crDr === "Dr" ? "col-red" : "col-green"}`}>
                  {row.balance ? Math.round(row.balance) : 0}
                </td>
                <td className={`text-center ${row.crDr === "Dr" ? "col-red" : "col-green"}`}>{row.crDr}</td>
                <td className="col-muted">{row.document}</td>
                <td className="col-muted">{formatUiDateTime(row.addTime, "-")}</td>
              </tr>
            ))}
          </tbody>
          {data.length > 0 && (
            <tfoot>
              <tr>
                <td colSpan={4} />
                <td className="text-right col-red">{Math.round(debitTotal)}</td>
                <td className="text-right col-green">{Math.round(creditTotal)}</td>
                <td colSpan={4} />
              </tr>
            </tfoot>
          )}
        </table>
        {ledgerReportLoading && <div className="rpt-loading">Loading ...</div>}
        {!ledgerReportLoading && data.length === 0 && <div className="rpt-empty">No data found</div>}
      </div>
    </div>
  );
}

// ─── Main Page ───────────────────────────────────────────────────────────────

function ReportLedger({ darkTheme = false }) {
  const dispatch   = useDispatch();
  const localData  = getSessionData();

  const { ledgerReportList, ledgerReportLoading } = useSelector(({ report }) => report);
  const { accountOptionList, cashbookList, agentORSubBrokerList } = useSelector(({ common }) => common);
  const { userAuthorityList } = useSelector(({ admin }) => admin);
  const { userRole } = useSelector(({ auth }) => auth);

  const initialSaveState = {
    userId: "", isDateFilter: false, startDate: new Date(), endDate: new Date(),
    filter: "", userType: "", reportType: "1", roleType: { label: "All", value: "All" },
  };

  const [initialLeaderReport, setInitialLeaderReport] = useState(initialSaveState);
  const [headType, setHeadType] = useState(null);
  const [reportTypeValue, setReportTypeValue] = useState("1");

  const reportLedgerSchema = Yup.object().shape({
    userId: Yup.object().when("userType", {
      is: (ut) => ut?.value !== 0,
      then: Yup.object().required("*Required"),
      otherwise: Yup.object().nullable(),
    }),
  });

  useEffect(() => {
    setHeadType(optionsOfHead[0]);
    return () => { dispatch(setAccountOptionList([])); dispatch(setAgentORSubBrokerList([])); };
  }, []);

  useEffect(() => {
    if (!headType) return;
    const updated = { ...initialSaveState, userType: headType, isDateFilter: headType.value === 2 };
    setInitialLeaderReport(updated);
    switch (headType.value) {
      case 1: dispatch(getAccountCommonList({ roleName: "User"       })); break;
      case 2: dispatch(getAccountCommonList({ roleName: "Cashbook"   })); break;
      case 3: dispatch(getAccountCommonList({ roleName: "Sub Broker" })); break;
      case 4: dispatch(getAuthoritysList());                               break;
      default: break;
    }
    if (userRole === "User") {
      dispatch(getLedgerReportList({ ...updated, userId: { label: localData.userName, value: localData.userId } }));
    }
  }, [headType]);

  const getUserOptions = (ut) => {
    switch (ut?.value) {
      case 1: return accountOptionList;
      case 2: return cashbookList;
      case 3: return agentORSubBrokerList;
      case 4: return userAuthorityList.filter(i => i.value !== localData.userId);
      default: return [];
    }
  };

  return (
    <div className={`rpt-page${darkTheme ? " rpt-page--dark" : ""}`}>
      {ledgerReportLoading && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,.3)", zIndex: 999 }}>
          <Spinner color="primary" />
        </div>
      )}

      {/* Title */}
      <div className="rpt-title-bar">
        <div className="rpt-title">Ledger Report</div>
      </div>
      <hr className="rpt-divider" />

      {/* Filters */}
      {userRole !== "User" && (
        <Formik
          enableReinitialize
          initialValues={initialLeaderReport}
          validationSchema={reportLedgerSchema}
          onSubmit={(values) => dispatch(getLedgerReportList({ ...values, reportType: reportTypeValue }))}
        >
          {({ handleSubmit, values, handleChange, handleBlur, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <div className="rpt-filter">
                {/* Row 1 */}
                <div className="rpt-filter-row">
                  {/* Report type */}
                  <div>
                    <div className="rpt-filter-label">Report Type</div>
                    <div className="rpt-radio-group">
                      {[{ val: "1", label: "On Screen" }, { val: "2", label: "PDF View" }, { val: "3", label: "Excel" }].map(({ val, label }) => (
                        <label key={val} className={`rpt-radio ${reportTypeValue === val ? "active" : ""}`}>
                          <input type="radio" name="reportType" value={val} checked={reportTypeValue === val}
                            onChange={() => { handleChange("reportType")(val); setReportTypeValue(val); }} />
                          {label}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Account type */}
                  <div style={{ minWidth: 160 }}>
                    <div className="rpt-filter-label">Account Type</div>
                    <Select options={optionsOfHead} styles={stylesSelect} components={{ DropdownIndicator, ClearIndicator }}
                      placeholder="Account Type" name="userType" value={values.userType} isClearable
                      onBlur={() => handleBlur({ target: { name: "userType" } })}
                      onChange={(opt) => { setHeadType(opt); handleChange("userId")(""); handleChange({ target: { name: "userType", value: opt } }); }}
                    />
                  </div>

                  {/* Client */}
                  {headType?.value !== 0 && (
                    <div style={{ minWidth: 180 }}>
                      <div className="rpt-filter-label">Client</div>
                      <Select styles={stylesSelect} components={{ DropdownIndicator, ClearIndicator }}
                        name="userId" value={values.userId} options={getUserOptions(values.userType)}
                        placeholder="Select Client"
                        onBlur={() => handleBlur({ target: { name: "userId" } })}
                        onChange={(opt) => handleChange({ target: { name: "userId", value: opt } })}
                      />
                      <span style={{ fontSize: 10, color: "var(--red)" }}><ErrorMessage name="userId" /></span>
                    </div>
                  )}

                  <div style={{ alignSelf: "flex-end" }}>
                    <button type="submit" className="rpt-btn rpt-btn--primary">
                      <i className="material-icons-outlined">search</i> Get Ledger
                    </button>
                  </div>
                </div>

                <hr className="rpt-filter-sep" />

                {/* Row 2 – filters */}
                <div className="rpt-filter-row">
                  <span className="rpt-filter-label" style={{ alignSelf: "center", marginBottom: 0 }}>Filters:</span>

                  <label className="rpt-checkbox">
                    <input type="checkbox" checked={values.isDateFilter}
                      onChange={(e) => setFieldValue("isDateFilter", e.target.checked)} />
                    Date Filter
                  </label>

                  <div>
                    <div className="rpt-filter-label">From</div>
                    <DatePicker className="form-control" dateFormat={UI_DATEPICKER_FORMAT}
                      selected={values.startDate} onChange={(d) => setFieldValue("startDate", d)} />
                  </div>
                  <div>
                    <div className="rpt-filter-label">To</div>
                    <DatePicker className="form-control" dateFormat={UI_DATEPICKER_FORMAT}
                      selected={values.endDate} onChange={(d) => setFieldValue("endDate", d)} />
                  </div>

                  <div style={{ minWidth: 180 }}>
                    <div className="rpt-filter-label">Transaction Filter</div>
                    <Select options={optionsOfFilter} styles={stylesSelect} name="filter"
                      value={values.filter} isClearable
                      components={{ DropdownIndicator, ClearIndicator }} placeholder="Filter"
                      onChange={(opt) => handleChange({ target: { name: "filter", value: opt } })}
                    />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}

      {/* Table */}
      <TableReportLedger
        ledgerReportList={ledgerReportList}
        ledgerReportLoading={ledgerReportLoading}
        headType={headType}
        initialLeaderReport={initialLeaderReport}
      />

      <TradePopup />
    </div>
  );
}

export default ReportLedger;
